/*
 * Doto x Searchanise — Fake original price
 * Mirrors the PDP logic in product-price-with-fake.liquid:
 *   fake/original price = current price x 1.12
 *
 * Scope: Searchanise Search Results / Smart Navigation product cards.
 */

const DOTO_SEARCHANISE_FAKE_PRICE_MULTIPLIER = 1.12;
const DOTO_SEARCHANISE_RESULTS_SELECTOR = '#snize_results, .snize-search-results';
const DOTO_SEARCHANISE_CARD_SELECTOR = '.snize-product';
const DOTO_SEARCHANISE_PRICE_SELECTOR = '.snize-price-list .snize-price, .snize-price';
const DOTO_SEARCHANISE_FAKE_CLASS = 'doto-searchanise-fake-price';
const DOTO_SEARCHANISE_SHIPPING_CLASS = 'doto-searchanise-free-shipping';

const dotoSearchaniseMoneyFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

function dotoParseSearchaniseMoney(value) {
  if (!value) return null;

  const compact = String(value)
    .replace(/\s/g, '')
    .replace(/[^\d.,-]/g, '');

  if (!compact) return null;

  const lastDot = compact.lastIndexOf('.');
  const lastComma = compact.lastIndexOf(',');
  let normalized = compact;

  // Supports both 5,619.00 and 5.619,00 formats.
  if (lastDot > -1 && lastComma > -1) {
    if (lastDot > lastComma) {
      normalized = compact.replace(/,/g, '');
    } else {
      normalized = compact.replace(/\./g, '').replace(',', '.');
    }
  } else if (lastDot > -1) {
    const decimalLength = compact.length - lastDot - 1;
    normalized = decimalLength > 0 && decimalLength <= 2
      ? compact.replace(/,/g, '')
      : compact.replace(/\./g, '');
  } else if (lastComma > -1) {
    const decimalLength = compact.length - lastComma - 1;
    normalized = decimalLength > 0 && decimalLength <= 2
      ? compact.replace(/\./g, '').replace(',', '.')
      : compact.replace(/,/g, '');
  }

  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function dotoGetSearchaniseCurrentPriceElement(card) {
  const candidates = Array.from(card.querySelectorAll(DOTO_SEARCHANISE_PRICE_SELECTOR))
    .filter((element) => !element.classList.contains(DOTO_SEARCHANISE_FAKE_CLASS));

  if (!candidates.length) return null;

  // Searchanise marks the discounted/current price with this class when applicable.
  const discountedPrice = candidates.find((element) =>
    element.classList.contains('snize-price-with-discount')
  );

  if (discountedPrice) return discountedPrice;

  // Otherwise prefer the visible non-crossed-out price if more than one exists.
  const visibleCurrentPrice = candidates.find((element) => {
    const styles = window.getComputedStyle(element);
    const decoration = `${styles.textDecorationLine} ${styles.textDecoration}`;
    return styles.display !== 'none'
      && styles.visibility !== 'hidden'
      && !decoration.includes('line-through');
  });

  return visibleCurrentPrice || candidates[0];
}

function dotoApplySearchaniseFakePrice(card) {
  const currentPriceElement = dotoGetSearchaniseCurrentPriceElement(card);
  if (!currentPriceElement) return;

  const currentPrice = dotoParseSearchaniseMoney(currentPriceElement.textContent);
  if (!currentPrice || currentPrice <= 0) return;

  const priceList = currentPriceElement.closest('.snize-price-list') || currentPriceElement.parentElement;
  if (!priceList) return;

  const fakePrice = currentPrice * DOTO_SEARCHANISE_FAKE_PRICE_MULTIPLIER;
  const formattedFakePrice = dotoSearchaniseMoneyFormatter.format(fakePrice);

  let fakePriceElement = card.querySelector(`.${DOTO_SEARCHANISE_FAKE_CLASS}`);

  if (!fakePriceElement) {
    fakePriceElement = document.createElement('span');
    fakePriceElement.className = DOTO_SEARCHANISE_FAKE_CLASS;
    fakePriceElement.setAttribute('data-doto-searchanise-fake-price', 'true');
    currentPriceElement.insertAdjacentElement('afterend', fakePriceElement);
  } else if (fakePriceElement.parentElement !== priceList) {
    currentPriceElement.insertAdjacentElement('afterend', fakePriceElement);
  }

  if (fakePriceElement.textContent !== formattedFakePrice) {
    fakePriceElement.textContent = formattedFakePrice;
  }

  fakePriceElement.dataset.dotoCurrentPrice = currentPrice.toFixed(2);
  fakePriceElement.dataset.dotoMultiplier = String(DOTO_SEARCHANISE_FAKE_PRICE_MULTIPLIER);
}

function dotoApplySearchaniseFreeShipping(card) {
  const priceList = card.querySelector('.snize-price-list');
  if (!priceList) return;

  let shippingElement = card.querySelector(`.${DOTO_SEARCHANISE_SHIPPING_CLASS}`);

  if (!shippingElement) {
    shippingElement = document.createElement('div');
    shippingElement.className = DOTO_SEARCHANISE_SHIPPING_CLASS;
    shippingElement.setAttribute('data-doto-searchanise-free-shipping', 'true');
    shippingElement.setAttribute('aria-label', 'Envío gratis');

    shippingElement.innerHTML = `
      <svg class="doto-searchanise-free-shipping__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M3 6.5h11v10H3z"></path>
        <path d="M14 10h3.5l3.5 3.5v3H14z"></path>
        <circle cx="7" cy="18" r="2"></circle>
        <circle cx="18" cy="18" r="2"></circle>
        <path d="M5 10h5"></path>
        <path d="M3 13h4"></path>
      </svg>
      <span class="doto-searchanise-free-shipping__text">ENVÍO GRATIS</span>
    `;
  }

  if (shippingElement.previousElementSibling !== priceList) {
    priceList.insertAdjacentElement('afterend', shippingElement);
  }
}



function dotoSetImportant(element, property, value) {
  if (!element?.style) return;
  const currentValue = element.style.getPropertyValue(property);
  const currentPriority = element.style.getPropertyPriority(property);
  if (currentValue === value && currentPriority === 'important') return;
  element.style.setProperty(property, value, 'important');
}

function dotoNormalizeCtaText(value) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}

function dotoFindSearchaniseMobileCta(card) {
  const textCandidates = Array.from(
    card.querySelectorAll('a, button, [role="button"], .snize-button, span, div')
  );

  const exactLabel = /^(VER(?:\s+PRODUCTO)?|VER\s*(?:\.{3}|…)|VIEW(?:\s+PRODUCT)?|ADD\s+TO\s+CART|AGREGAR|AÑADIR(?:\s+AL\s+CARRITO)?)$/i;

  // Find the smallest element whose visible label is the CTA text. This also
  // works if Searchanise changes the class name on mobile.
  const labelNode = textCandidates
    .filter((element) => {
      const text = dotoNormalizeCtaText(element.textContent);
      if (!exactLabel.test(text)) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    })
    .sort((a, b) => a.children.length - b.children.length)[0];

  if (labelNode) {
    const clickable = labelNode.closest('a, button, [role="button"], .snize-button');
    if (clickable && card.contains(clickable)) return clickable;
    return labelNode;
  }

  // Fallback to known Searchanise CTA classes.
  const classCandidates = Array.from(card.querySelectorAll([
    '.snize-button',
    '.snize-view-product-button',
    '.snize-add-to-cart-button',
    '[class*="snize"][class*="button"]'
  ].join(',')));

  return classCandidates.find((element) => {
    const text = dotoNormalizeCtaText(element.textContent);
    const style = window.getComputedStyle(element);
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && (text.includes('VER') || text.includes('VIEW') || text.includes('AGREG') || text.includes('AÑAD'));
  }) || null;
}

function dotoForceSearchaniseMobileCta(card) {
  // Searchanise can switch to its mobile DOM before/after the theme breakpoint.
  // Scope by either actual mobile-design class or viewport width.
  const mobileRoot = card.closest('.snize-mobile-design');
  if (!mobileRoot && !window.matchMedia('(max-width: 991px)').matches) return;

  const button = dotoFindSearchaniseMobileCta(card);
  if (!button) return;

  button.setAttribute('data-doto-mobile-full-cta', 'true');

  // Fix the label even when Searchanise literally renders "VER ...".
  const labelText = dotoNormalizeCtaText(button.textContent);
  if (/^VER\s*(?:\.{3}|…)?$/i.test(labelText)) {
    const nestedLabel = Array.from(button.querySelectorAll('span, strong, em')).find((node) =>
      /^VER\s*(?:\.{3}|…)?$/i.test(dotoNormalizeCtaText(node.textContent))
    );
    if (nestedLabel) {
      nestedLabel.textContent = 'VER PRODUCTO';
    } else {
      button.textContent = 'VER PRODUCTO';
    }
  }

  const buttonStyles = {
    width: '100%',
    minWidth: '0px',
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 100%',
    alignSelf: 'stretch',
    position: 'relative',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    inset: 'auto',
    transform: 'none',
    marginTop: '16px',
    marginRight: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    paddingTop: '0px',
    paddingRight: '8px',
    paddingBottom: '0px',
    paddingLeft: '8px',
    height: '44px',
    minHeight: '44px',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textOverflow: 'clip',
    float: 'none'
  };

  Object.entries(buttonStyles).forEach(([property, value]) => {
    const cssProperty = property.replace(/[A-Z]/g, (match) => '-' + match.toLowerCase());
    dotoSetImportant(button, cssProperty, value);
  });

  // The main blocker on some Searchanise mobile templates is NOT the button:
  // one or two wrapper elements are width:auto / inline-block. Stretch those too.
  let wrapper = button.parentElement;
  let level = 0;
  while (wrapper && wrapper !== card && level < 3) {
    wrapper.setAttribute('data-doto-mobile-cta-wrapper', String(level + 1));
    dotoSetImportant(wrapper, 'width', '100%');
    dotoSetImportant(wrapper, 'min-width', '0px');
    dotoSetImportant(wrapper, 'max-width', '100%');
    dotoSetImportant(wrapper, 'box-sizing', 'border-box');
    dotoSetImportant(wrapper, 'flex', '1 1 100%');
    dotoSetImportant(wrapper, 'align-self', 'stretch');
    dotoSetImportant(wrapper, 'float', 'none');
    dotoSetImportant(wrapper, 'margin-left', '0px');
    dotoSetImportant(wrapper, 'margin-right', '0px');
    wrapper = wrapper.parentElement;
    level += 1;
  }

  button.querySelectorAll('*').forEach((child) => {
    dotoSetImportant(child, 'max-width', 'none');
    dotoSetImportant(child, 'white-space', 'nowrap');
    dotoSetImportant(child, 'overflow', 'visible');
    dotoSetImportant(child, 'text-overflow', 'clip');
  });
}

function dotoRefreshSearchaniseFakePrices() {
  const roots = document.querySelectorAll(DOTO_SEARCHANISE_RESULTS_SELECTOR);
  if (!roots.length) return;

  roots.forEach((root) => {
    root.querySelectorAll(DOTO_SEARCHANISE_CARD_SELECTOR).forEach((card) => {
      dotoApplySearchaniseFakePrice(card);
      dotoApplySearchaniseFreeShipping(card);
      dotoForceSearchaniseMobileCta(card);
    });
  });
}

let dotoSearchaniseRefreshScheduled = false;

function dotoScheduleSearchaniseFakePriceRefresh() {
  if (dotoSearchaniseRefreshScheduled) return;
  dotoSearchaniseRefreshScheduled = true;

  window.requestAnimationFrame(() => {
    dotoSearchaniseRefreshScheduled = false;
    dotoRefreshSearchaniseFakePrices();
  });
}

function dotoInitSearchaniseFakePrice() {
  dotoScheduleSearchaniseFakePriceRefresh();

  [80, 250, 700, 1500, 3000, 5000].forEach((delay) => {
    window.setTimeout(dotoScheduleSearchaniseFakePriceRefresh, delay);
  });

  const observer = new MutationObserver((mutations) => {
    const hasRelevantMutation = mutations.some((mutation) => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;

      if (target?.closest?.(DOTO_SEARCHANISE_RESULTS_SELECTOR)) return true;

      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false;
        return node.matches(DOTO_SEARCHANISE_RESULTS_SELECTOR)
          || Boolean(node.querySelector(DOTO_SEARCHANISE_RESULTS_SELECTOR));
      });
    });

    if (hasRelevantMutation) {
      dotoScheduleSearchaniseFakePriceRefresh();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // Searchanise recalculates mobile CTA geometry on viewport/layout changes.
  window.addEventListener('resize', dotoScheduleSearchaniseFakePriceRefresh, { passive: true });
  window.addEventListener('orientationchange', dotoScheduleSearchaniseFakePriceRefresh, { passive: true });
  document.addEventListener('Searchanise.Loaded', dotoScheduleSearchaniseFakePriceRefresh);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dotoInitSearchaniseFakePrice, { once: true });
} else {
  dotoInitSearchaniseFakePrice();
}
